import forgotPasswordTypes from './forgotPasswordTypes'
const initialState = {
  loading: false
}

export default (state = initialState, { type }) => {
  switch (type) {
    case forgotPasswordTypes.SEND_FORGOT_PASSWORD_EMAIL :
      return {
        ...state,
        loading: true
      }

    case forgotPasswordTypes.SEND_FORGOT_PASSWORD_EMAIL_RESPONSE:
      return {
        ...state,
        loading: false
      }

    default:
      return state
  }
}
